<script>
    export let fill = 'var(--accent)'
    export let width = '32px'
</script>

<svg version="1.1" x="0px" y="0px" viewBox="0 0 297.001 297.001" style="fill: {fill}; width: {width}">
    <path d="M273.522,123.76c12.609-23.496,15.184-45.727,7.625-66.157c-14.729-39.813-62.923-56.279-64.967-56.961
        c-6.523-2.174-13.571,1.351-15.744,7.872c-2.174,6.521,1.352,13.569,7.871,15.743c0.389,0.129,39.033,13.704,49.494,41.983
        c4.002,10.816,3.406,22.902-1.723,36.061c-30.392-26.224-76.002-25.169-97.522-22.876l-11.735-49.722
        c-0.777-3.294-2.862-6.129-5.774-7.851c-2.914-1.726-6.404-2.187-9.662-1.284L86.347,33.044L41.309,20.567
        c-3.307-0.915-6.847-0.426-9.781,1.355c-2.934,1.781-5.002,4.695-5.716,8.053l-12.92,61.187c-1.413,5.768-2.179,11.788-2.179,17.984
        c0,35.475,24.555,65.308,57.556,73.435c15.941,10.719,15.141,32.684,5.65,65.257c-7.006,24.049,5.287,39.699,19.674,44.065
        c14.669,4.454,33.45-2.381,39.489-21.519c8.102-25.679,21.541-36.41,30.587-37.799c3.007-0.46,5.561,0.12,6.512,1.48
        c1.071,1.531,0.884,5.384-1.951,10.538c-14.338,26.067-1.227,40.794,3.132,44.687c5.737,5.123,13.182,7.711,20.788,7.711
        c6.841-0.001,13.813-2.095,19.785-6.321c33.738-23.877,57.26-52.629,68.018-83.148C290.245,178.335,287.923,148.851,273.522,123.76z
        M35.605,109.146c0-27.979,22.763-50.741,50.741-50.741c27.979,0,50.742,22.762,50.742,50.741s-22.763,50.742-50.742,50.742
        C58.368,159.888,35.605,137.126,35.605,109.146z M197.555,270.361c-3.344,2.366-7.054,2.973-9.614,0.361
        c-3.056-3.116-1.485-7.605,2.1-14.123c7.35-13.363,7.548-26.775,0.542-36.796c-6.534-9.349-18.004-13.763-30.688-11.823
        c-21.862,3.354-40.76,23.882-50.552,54.912c-1.771,5.612-6.35,5.849-8.522,5.189c-5.858-1.777-3.779-10.615-3.002-13.28
        c5.388-18.496,14.077-48.343,3.18-71.458c34.716-6.843,60.983-37.505,60.983-74.197c0-1.688-0.076-3.357-0.186-5.018
        c20.675-2.125,66.994-3.015,87.482,27.719C276.89,173.262,256.102,228.926,197.555,270.361z" />
    <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
</svg>

<style>
svg {
    cursor: pointer;
}
</style>